// https://github.com/airbrake/airbrake-js/tree/master/packages/browser

import { Notifier } from '@airbrake/browser'

window.isAirbrakeEnabled = false
window.airbrake = undefined

/**
 * js airbrake init
 */
window.initAirbrake = function (host = '', projectId = 0, projectKey = '') {
  window.airbrake = new Notifier({
    host: host,
    projectId: projectId,
    projectKey: projectKey,
    environment: 'production',
  })
  window.isAirbrakeEnabled = true
}

/**
 * js airbrake üzenet küldő
 *
 * @param error
 * @param details
 */
window.sendWarning = async function (error, details = { _details: '' }) {
  if (!window.isAirbrakeEnabled || await window.isMessageIgnored(error.message)) {
    console.error('error: ' + error)
    console.error('params:')
    console.error(details)
    return
  }
  airbrake.notify(
    {
      error: error,
      params: details,
    },
  ).then(function (notice) {
    if (notice.id) {
      console.log('notice id:', notice.id)
    } else {
      console.log('notify failed:', notice.error)
    }
  })
}

/**
 * jelenlegi error message ignorálva van-e
 *
 * @param {String} message
 * @return {Promise<boolean>}
 */
window.isMessageIgnored = async function (message) {
  let isIgnored = false
  await window.ignoredErrorMessageList.forEach(ignoredMessage => {
    if (message.includes(ignoredMessage)) {
      isIgnored = true
    }
  })
  return isIgnored
}

/**
 * js error catch
 *
 * @param msg
 * @param url
 * @param line
 * @param col
 * @param error
 * @returns {boolean}
 */
window.onerror = function (msg, url, line, col, error) {
  window.sendWarning(error, {
    _errorMessage: msg,
    _file: url,
    _line: line,
    _col: col,
    _version: __VERSION__,
  })
  return true
}

/**
 * ignorálandó üzenetek listája
 *
 * nem tudtuk előidézni,
 * https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a
 * és hogy egyelőre ignore, mert nem okoz hibát
 * az errbit küldésnél kihagyjuk, csak simán nem küldjük. console kiirás megmarad
 *
 * @type {[
 *   String,
 * ]}
 */
window.ignoredErrorMessageList = [
  'via a navigation guard',
]
